import { useEffect, useState } from "react";
import { listenToWineList } from "../GetServices";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Button from 'react-bootstrap/Button';
import { useCart } from '../../context/CartContext';
import FilteredButtons from "../ui/FilteredButtons";
import { Popup } from "../ui/Utilities";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import '../../styles/WineDisplay.css';
import { useNavigate } from 'react-router-dom';
import { AnimatedDiv } from "../ui/Animations";


function WineDisplay() {
  const [wineList, setWineList] = useState([]);
  const [selectedMillesime, setSelectedMillesime] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [selectedWine, setSelectedWine] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [selectedFormats, setSelectedFormats] = useState({});
  const { addToCart, cart, setCart } = useCart();
  const [selectedColor, setSelectedColor] = useState(null);

  const [showNotification, setShowNotification] = useState(false);
  const navigate = useNavigate();

  const togglePopup = (wine) => {
    setSelectedWine(wine)
    setShowPopup(!showPopup);
    document.body.classList.toggle('no-scroll', !showPopup);
  };
  const closePopup = () => {
    setShowPopup(false);
    document.body.classList.remove('no-scroll');
  };

  useEffect(() => {
    const unsubscribe = listenToWineList((data) => {
      setWineList(data);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Pré-sélection du format si un seul disponible
    const autoFormats = {};
    wineList.forEach(wine => {
      const formats = wine.formats ? Object.keys(wine.formats) : [];
      if (formats.length === 1) {
        autoFormats[wine.id] = formats[0];
      }
    });
    setSelectedFormats(autoFormats);
  }, [wineList]);

  const filteredWines = wineList
  .filter((wine) => {
        const matchesColor = selectedColor ? wine.color?.toLowerCase() === selectedColor : true;
    const matchesMillesime = selectedMillesime ? wine.millesime === selectedMillesime : true;


  // ✅ Ne garder que les vins qui ont au moins un format avec du stock
  const hasAvailableStock = wine.formats && Object.values(wine.formats).some(format => format.stock > 0);
    return matchesMillesime && matchesColor && hasAvailableStock;
  })
  .sort((a, b) => a.index - b.index)

  const handleQuantityChange = (wineKey, value) => {
    setQuantities(prev => ({
      ...prev,
      [wineKey]: Math.max(0, value)
    }));
  };

  const handleAddToCart = (wine, selectedFormat) => {
    const key = `${wine.id}-${selectedFormat}`;
    const quantityToAdd = quantities[key] || 0;

    const formatData = wine.formats?.[selectedFormat];

    if (quantityToAdd > 0 && wine.formats[selectedFormat]) {
      const wineToAdd = {
        ...wine,
         id: `${wine.id}-${selectedFormat}`, // 🔥 ID unique pour chaque format
          quantity: quantityToAdd,
      price: formatData.price,
      bottle_size: selectedFormat,
      selectedFormat: selectedFormat, // utile pour affichage
    };
      addToCart(wineToAdd, quantityToAdd);
      setShowNotification(true);
    }
  };

  const millesimeItems = [
    { label: 'Millésime 2025', value: 2025 },
    { label: 'Millésime 2024', value: 2024 },
    { label: 'Millésime 2023', value: 2023 },
    { label: 'Millésime 2022', value: 2022 },
    { label: 'Tous les vins', value: null },
  ];

  const colorItems = [
  { label: 'Tous', value: null },
  { label: 'Rouge', value: 'rouge', icon:'🍷' },
  { label: 'Blanc', value: 'blanc', icon:'🥂' },
  { label: 'Rosé', value: 'rosé', icon: '🍷'  }
];

  const getBackgroundClass = (description) => {
    description = description.toLowerCase();
    if (description.includes('barrique')) return 'bg-barrel';
    if (description.includes('raisin') || description.includes('cep')) return 'bg-grappe';
    if (description.includes('elevage') || description.includes('cuve')) return 'bg-bottle';
    if (description.includes('parcelle')) return 'bg-parcelle';
    return 'bg-wine';
  };

  return (
    <div>
      <FilteredButtons items={colorItems} setSelected={setSelectedColor} selectedValue={colorItems} />
      {selectedColor === null && ( 
         <FilteredButtons
         items={millesimeItems}
         setSelected={setSelectedMillesime}
         selectedValue={selectedMillesime}
         />
         )}

      {filteredWines.map((wine) => {
        const formats = wine.formats || {};
        const formatKeys = Object.keys(formats);
        const selectedFormat = selectedFormats[wine.id];
        const localWineImage = `/wine_assets/${wine.image}.jpeg`;

        return (
          <AnimatedDiv key={wine.id} delay={0.3}>
            <div className="wine-container">
              <div className="wine_image_responsive">
                <img src={localWineImage} alt={wine.variety} className="bottle" />
              </div>
              <div className="wine-details">
                <div className="title_size"> {wine.variety} {wine.millesime} - {wine.location} </div>
                <div className="wine-list-description1"> {wine.joke}  </div>
                <ul className="wine-list-description2">
                  <li className={getBackgroundClass(wine.description_1)}>{wine.description_1}</li>
                  <li className={getBackgroundClass(wine.description_2)}>{wine.description_2}</li>
                  <li className={getBackgroundClass(wine.description_3)}>{wine.description_3}</li>
               
                </ul>

                <div className="btn_popup">
                  <Button onClick={() => togglePopup(wine)} className="btn_informations">
                    <FontAwesomeIcon icon={faFileAlt} style={{ marginRight: '8px' }} />
                    Fiche technique
                    
                  </Button>
                
                  

                  <div className="list_option">
                  {formatKeys.length > 0 && (
                    <div className="format-selection">
                      {formatKeys.length > 1 ? (
                        <select
                          className="select_quantity"
                          value={selectedFormat || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSelectedFormats(prev => ({ ...prev, [wine.id]: value }));
                          }}
                        >
                          <label> Contenance </label>
                          <option value=""> Choisir une option </option>
                          {formatKeys.map((size) => (
                            <option key={size} value={size}>
                              {size} cl - CHF {formats[size].price}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <p>{formatKeys[0]} cl - CHF {formats[formatKeys[0]].price}</p>
                      )}
                    </div>
                  )}

                  {selectedFormat && formats[selectedFormat]?.stock > 0 && (
                    <div className="quantity-control">
                      <select
                        className="select_quantity"
                        value={quantities[`${wine.id}-${selectedFormat}`] || 0}
                        onChange={(e) => handleQuantityChange(`${wine.id}-${selectedFormat}`, parseInt(e.target.value))}
                      >
                        {[...Array(Math.min(25, formats[selectedFormat].stock + 1)).keys()].map((num) => (
                          <option key={num} value={num}>{num}</option>
                        ))}
                      </select>

                     <div className="btn_add" onClick={() => handleAddToCart({ ...wine, image: localWineImage }, selectedFormat)}>
                        <ShoppingCartIcon />
                      </div>
                    </div>
                  )}

                  {selectedFormat && formats[selectedFormat]?.stock === 0 && (
                    <button className="btn_out_of_stock" disabled>Épuisé</button>
                  )}
                  </div>

                  {showNotification && (
                    <div className={`notification ${showNotification ? 'show' : ''}`}>
                      <p className="addBasket_notif"> Vin ajouté au panier ! </p>
                      <p className="recapOrder_notif"> Récapitulatif de votre commande </p>
                      {cart.map((e, index) => (
                        <div className="item_notif" key={index}>
                          <img src={e.image} alt={e.variety} className="bottle_notif" />
                          <div className="cart_item_notif">
                            <p className="text_notif"> {e.variety} {e.millesime} ({e.bottle_size}cl)</p>
                            <p className="price_notif"> CHF {e.price * e.quantity.toFixed(2)} .- </p>
                          </div>
                        </div>
                      ))}
                      <div className="notification-buttons">
                        <button onClick={() => setShowNotification(false)}>Continuer vos achats</button>
                        <button onClick={() => navigate('/cave/panier')}> Aller au panier</button>
                        <button className="close_btn" onClick={() => setShowNotification(false)}>×</button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </AnimatedDiv>
        );
      })}
      <Popup show={showPopup} onClose={closePopup} wine={selectedWine} />
    </div>
  );
}

export default WineDisplay;
